import { render } from "./DesktopSidebar.vue?vue&type=template&id=4a5ef5ea"
import script from "./DesktopSidebar.vue?vue&type=script&lang=js"
export * from "./DesktopSidebar.vue?vue&type=script&lang=js"
script.render = render

export default script